import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-14tw181-0"
})(["&&&{margin:12px 0 36px;}"]);